// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"i0-z","subtitle":"j0-z","wrapper":"k0-z","leftArrow":"l0-z","rightArrow":"m0-z"};